/** Badge tones for the advanced report (colour never carries meaning alone: every badge has a text label). */
import type { FindingStatus, ResolvabilityMode } from '@qm/contracts/audit-remediation';
import type { Grade, Severity } from '@qm/contracts/audit-analysis';

type Tone = 'neutral' | 'accent' | 'warning' | 'error' | 'success';

export const severityTone = (s: Severity): Tone => (s === 'critical' ? 'error' : s === 'high' ? 'warning' : s === 'medium' ? 'accent' : 'neutral');

export const gradeTone = (g: Grade): Tone => (g === 'A' || g === 'B' ? 'success' : g === 'C' ? 'accent' : g === 'D' ? 'warning' : g === 'F' ? 'error' : 'neutral');

export const statusTone = (s: FindingStatus): Tone =>
  s === 'verified' || s === 'applied' ? 'success'
    : s === 'failed' || s === 'regressed' ? 'error'
      : s === 'in_progress' || s === 'awaiting_approval' || s === 'applying' ? 'accent'
        : s === 'accepted_risk' ? 'warning' : 'neutral';

export const resolvabilityTone = (m: ResolvabilityMode): Tone => (m === 'auto' ? 'success' : m === 'assisted' ? 'accent' : m === 'expert' ? 'warning' : 'neutral');
